"use client";
import { Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import React from "react";
import Link from "next/link";

interface AddToCartSuccessMessageProps {
  item: {
    seo_url?: string;
    name: string;
    edited?: boolean;
  };
}

const AddToCartSuccessMessage: React.FC<AddToCartSuccessMessageProps> = ({ item }) => {
  return item.edited ? (
    <Trans>
      Success: You have edited
      <Link href={`/product/${item.seo_url}`} data-testid="alert-product" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {item.name}
        </Typography>
      </Link>
      to your
      <Link href="/checkout" data-testid="alert-cart" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          shopping cart
        </Typography>
      </Link>
      !
    </Trans>
  ) : (
    <Trans>
      Success: You have added
      <Link href={`/product/${item.seo_url}`} data-testid="alert-product" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {item.name}
        </Typography>
      </Link>
      to your
      <Link href="/checkout" data-testid="alert-cart" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          shopping cart
        </Typography>
      </Link>
      !
    </Trans>
  );
};

export default AddToCartSuccessMessage;
